<template>
    <div class="mt-4">
        <div class="row justify-content-center mt-5 mb-3">
            <div class="counter p-2 col-6 text-center">
                <canvas id="myChart" width="400" height="230"></canvas>
            </div>
            <div class="counter p-2 col-6 text-center">
                <canvas id="eligibilityChart" width="400" height="230"></canvas>
            </div>
        </div>
        <div class="d-flex flex-row justify-content-center mt-5 mb-3 report-summary">
            <counter v-bind:to="enrolled.all" label="Total Customers"></counter>
            <counter v-bind:to="eligible" label="Eligible Customers"></counter>
            <counter v-bind:to="cancelled.all" label="Cancelled Customers"></counter>
            <counter v-bind:to="active.current" v-bind:label="'Active ' + activePercentage"></counter>
        </div>
    </div>
</template>

<script>

    export default {
        name: "ReportSummary",
        props: ['revenue', 'enrolled', 'active', 'cancelled', 'eligible', 'activePercentage','report'],
        mounted() {
            let ctx = document.getElementById('myChart');
            let elg = document.getElementById('eligibilityChart');
            let totChart = new Chart(ctx, JSON.parse(this.report.charts.tot));
            let elgChart = new Chart(elg, JSON.parse(this.report.charts.elg));
        }
    }
</script>

<style scoped>
</style>
